angular
    .module('components', [
        'components.userReport',
        'components.caOrderSearchResult',
        'components.caBudgetImport',
        'components.caAddressForm',
        'components.caContactInfoForm',
        'components.caNewAddressForm',
        'components.caNewContactInfoForm',
        'components.caDiscountMultiselect',
        'components.caBarcodeScanningInput',
        'components.caOrderArticles',
        'components.caOrderMetaData',
        'components.caOrderRowsDelivery',
        'components.caOrderRowsEdit',
        'components.caOrderScannerNavigation',
        'components.caOrderTotals',
        'components.caOrderArticleDeliveries',
        'components.caOrderArticleRows',
        'components.caOrderContent',
        'components.caPurchaseOrderArticlesSummaryGrid',
        'components.caOpenToBuyGrid',
        'components.caPurchaseOrderDistributionGrid',
        'components.caPurchaseOrderExtraOptions',
        'components.caPurchaseOrderSingleArticleSummaryGrid',
        'components.caArticleVariantsGrid',
        'components.caArticleVariantsGridCell',
        'components.caArticleSearchMultiSelect',
        'components.caItemGroupInline',
        'components.caArticleSelection',
        'components.caPricelistGrid',
        'components.caPriceRangeInput',
        'components.caVolumeDiscountSelector',
        'components.caImportFileList',
        'components.caMapOrDate',
        'components.caMapOrSelect',
        'components.caImportEditorSummary',
        'components.caImportEditorTextDropdown',
        'components.caImportEditorValidationErrors',
        'components.caImportRowsGrid',
        'components.createResellerOrderArticlesAmount',
        'components.createResellerOrderArticlesOverview',
        'components.createResellerOrderArticlesQuantity',
        'components.caResellerOrderProductSearchMultiSelect',
        'components.createResellerOrderArticlesAmount',
        'components.createResellerReturnOrderArticlesOverview',
        'components.createResellerReturnOrderArticlesQuantity',
        'components.caResellerReturnOrderProductSearchMultiSelect'
    ]);
